<template>
  <div>
    <div class="pre-context" v-infinite-scroll="loadMore" infinite-scroll-disabled="loading" v-if="!shownull">
      <div class="context-card flex flex-j-c-sa" v-for="(e, i) in pageLists" :key="i">
        <div class="card-left flex flex-j-c-sa flex-a-i-center">
          <div class="change-box" style="margin-bottom: 0.2rem;">
            <img v-lazy="{src:e.avatar_url, loading:require('@/assets/loading.gif'), error:require('@/assets/error.jpg')}" class="avatar_img" />
            <p style="font-size:0.14rem;color:#333333">{{e.true_name}}</p>
            <p style="margin-top:2px"><a :href="'tel:' + e.binding" style="color:#333333">{{e.binding}}</a></p>
          </div>
          <div class="change-box" @click="toSend(e, i)">
            <img src="@/assets/recruit/icon_shippeds@3x.png" />
            <!-- <img src="@/assets/recruit/icon_shipped@3x.png" v-if="Number(e.is_send) !== 0"/> -->
            <p>补充信息</p>
          </div>
          <div class="change-box" style="padding-top: 0.1rem" @click="showInvi(e, true)" v-if="e.show == 1 && e.commission != 3000.00">
            <img src="@/assets/recruit/icon_modify@3x.png" />
            <!-- <img src="@/assets/recruit/icon_shipped@3x.png" v-if="Number(e.is_send) !== 0"/> -->
            <p>修改推荐人</p>
          </div>
        </div>
        <div class="card-right flex flex-j-c-center" @click="topage(e)">
          <div class="flex text-line flex-a-i-center">
            <p class="text-left">时间：</p>
            <p class="text-right ellipsis">{{e.create_time}}</p>
          </div>
          <div class="flex text-line flex-a-i-center">
            <p class="text-left">志愿：</p>
            <p class="text-right ellipsis">{{e.first_name}}</p>
          </div>
          <!-- <div class="flex text-line flex-a-i-center">
                  <p class="text-left">层次：</p>
                  <p class="text-right ellipsis">{{e.second_name}}</p>
                </div> -->
          <div class="flex text-line flex-a-i-center">
            <p class="text-left">专业：</p>
            <p class="text-right ellipsis">【{{e.second_name}}】 {{e.goods_name}}</p>
          </div>
          <div class="flex text-line flex-a-i-center" v-if="e.inviter_name">
            <p class="text-left">推荐人：</p>
            <p class="text-right ellipsis">{{e.inviter_name}}</p>
          </div>
          <div class="flex text-line flex-a-i-center">
            <p class="text-left">证件号码：</p>
            <p>{{e.idcard}}</p>
          </div>
          <div class="flex text-line flex-a-i-center">
            <p class="text-left">服务校区：</p>
            <p class="text-right ellipsis">{{e.campus}}</p>
          </div>
          <div class="flex text-line flex-a-i-center" v-if="e.express">
            <p class="text-left">物流公司：</p>
            <p class="text-right ellipsis">{{e.express}}</p>
          </div>
          <div class="flex text-line flex-a-i-center" v-if="e.express_no">
            <p class="text-left">物流单号：</p>
            <p class="text-right ellipsis">{{e.express_no}}</p>
          </div>
          <div class="flex text-line flex-a-i-center" v-if="e.critical_true_name">
            <p class="text-left">联系人：</p>
            <p class="text-right ellipsis">{{e.critical_true_name}}</p>
          </div>
          <div class="flex text-line flex-a-i-center">
            <p class="text-left">联系人手机：</p>
            <p class="text-right ellipsis"><a :href="'tel:' + e.critical_mobile_phone">{{e.crash_mobile}}</a></p>
          </div>
        </div>
      </div>
    </div>

    <mt-popup v-model="popupVisible" popup-transition="popup-fade" position="bottom" class="mint-popup">
      <mt-picker :slots="slots" :itemHeight="50" :valueKey="Indexes" @change="onValuesChange" showToolbar ref="picker">
        <mt-header :title.sync="popupName">
          <mt-button slot="left" @click="popupVisible = false">取消</mt-button>
          <mt-button slot="right" @click="handleConfirm">确定</mt-button>
        </mt-header>
      </mt-picker>
    </mt-popup>

    <DataNull v-if="shownull" />
    <Nomore v-if="showNoMore" />

    <div class="mask" v-show="showMask">
      <div class="express-box">
        <!-- <van-radio-group v-model="radio" class="flex flex-j-c-sa">
              <van-radio name="1" checked-color="#FABD01">紧急联系人</van-radio>
              <van-radio name="2" checked-color="#FABD01">物流信息</van-radio>
            </van-radio-group> -->

        <!-- <van-tabs v-model="radio" animated>
              <van-tab title="紧急联系人">
              </van-tab>
              <van-tab title="物流信息">
              </van-tab>
            </van-tabs> -->
        <!-- <Navbar :selected.sync="selected" :selecteData.sync="selecteData"/> -->
        <div class="flex text-line flex-a-i-center" style="margin-top:0.2rem" v-show="selected === 0">
          <p class="text-left" style="text-align: left;">姓名：</p>
          <input type="text" class="text-style" style="font-size:0.125rem;width:60%;" v-model.trim="setData.true_name" placeholder="" />
        </div>
        <div class="flex text-line flex-a-i-center">
          <p class="text-left" style="text-align: left;">层次：</p>
          <!-- <p class="text-style" @click="showPopup('arrangement')" style="width:60%;text-align: left;">{{arrangement.name||'请选择'}}</p> -->
          <input type="text" class="text-style" style="font-size:0.125rem;width:60%;" readonly v-model.trim="arrangement.name" />
        </div>
        <div class="flex text-line flex-a-i-center">
          <p class="text-left" style="text-align: left;">院校：</p>
          <p class="text-style" @click="showPopup('college')" style="width:60%;text-align: left;">{{college.name||'请选择'}}</p>
        </div>
        <div class="flex text-line flex-a-i-center">
          <p class="text-left" style="text-align: left;">专业：</p>
          <p class="text-style" @click="showPopup('major')" style="width:60%;text-align: left;">{{major.name||'请选择'}}</p>
        </div>
        <div class="flex text-line flex-a-i-center">
          <p class="text-left" style="text-align: left;">服务校区：</p>
          <p class="text-style" @click="showPopup('servicCampus')" style="width:60%;text-align: left;">{{servicCampus.name||'请选择'}}</p>
        </div>
        <!-- <div class="flex text-line flex-a-i-center">
          <p class="text-left" style="text-align: left;">推荐人：</p>
          <p class="text-style" @click="showPopup('inviter')" style="width:60%;text-align: left;">{{inviter.true_name||'请选择'}}</p>
        </div> -->
        <div class="flex text-line flex-a-i-center" v-show="selected === 0">
          <p class="text-left" style="text-align: left;">联系电话：</p>
          <input type="number" class="text-style" style="font-size:0.125rem;width:60%;" v-model.trim="setData.binding" placeholder="" oninput="if(value.length > 11)value = value.slice(0, 11)" />
        </div>
        <div class="flex text-line flex-a-i-center" v-show="selected === 0">
          <p class="text-left" style="text-align: left;">证件号：</p>
          <input type="text" class="text-style" style="font-size:0.125rem;width:60%;" placeholder="请输入证件号" v-model.trim="setData.idcard" oninput="if(value.length > 18)value = value.slice(0, 18)" />
        </div>

        <!-- 联系地址 -->

        <div>

          <p style="text-align: left; color:#999">现住址：</p>
          <v-region-selects @change="regionChange" :town="true" />
          <p style="width:100%;text-align: center;">{{county}}</p>
        </div>

        <!-- <div class="flex text-line flex-a-i-center" v-show="selected === 0">
          <p class="text-left" style="text-align: left;">详细地址：</p>
          <input type="text" class="text-style" style="font-size:0.125rem;width:60%;" placeholder="请输入详细地址" v-model.trim="setData.address" />
        </div> -->

        <div class="flex text-line flex-a-i-center" v-show="selected === 0">
          <p class="text-left" style="text-align: left;">工作单位：</p>
          <input type="text" class="text-style" style="font-size:0.125rem;width:60%;" placeholder="请输入工作单位" v-model.trim="setData.unit" />
        </div>
        <div class="flex text-line flex-a-i-center" v-show="selected === 0">
          <p class="text-left" style="text-align: left;">紧急联系人：</p>
          <input type="text" class="text-style" style="font-size:0.125rem;width:80%;" placeholder="请输入紧急联系人姓名" v-model.trim="setData.crash_linkman" />
        </div>
        <div class="flex text-line flex-a-i-center" v-show="selected === 0">
          <p class="text-left" style="text-align: left;">手机号码：</p>
          <input type="text" class="text-style" style="font-size:0.125rem;width:80%;" placeholder="请输入紧急联系人手机号码" v-model.trim="setData.crash_mobile" oninput="if(value.length > 11)value = value.slice(0, 11)" />
        </div>
        <div class="flex text-line flex-a-i-center">
          <p class="text-left" style="text-align: left;">线索来源：</p>
          <p class="text-style" @click="showPopup('clue')" style="width:20%;text-align: center;">{{setData.clue||'请选择来源'}}</p>
          <p class="text-style" @click="showPopup('clueType')" style="width:50%;text-align: center;margin-left:5%">{{setData.clueType||'请选择渠道'}}</p>
        </div>
        <div class="flex text-line flex-a-i-center" style="margin-top:0.2rem;" v-show="selected === 1">
          <p class="text-left">物流公司：</p>
          <p class="text-style" @click="showPopup('ex')" style="width:60%;text-align: left;">{{setData.express}}</p>
        </div>
        <div class="flex text-line flex-a-i-center" v-show="selected === 1 && setData.express !== '校区自取'">
          <p class="text-left">物流单号：</p>
          <input type="text" class="text-style" style="font-size:0.125rem;width:60%;" v-model.trim="setData.express_no" placeholder="" />
        </div>

        <van-button type="default" class="express-box-btn" @click.native="saveExpress">确定</van-button>
        <img src="@/assets/home/Receive_icon_close@3x.png" class="box-close" @click="showMask = false">
      </div>
    </div>

    <div class="mask" v-show="showEdit">
      <!-- v-show="showEdit" -->
      <div class="express-box">

        <div class="upload-box flex flex-j-c-sb">
          <div class="change-box" style="margin-bottom: 0.2rem;">
            <img :src="setInviterChange.studentImg" class="avatar_img" />
            <p style="font-size:0.14rem;color:#333333">{{setInviterChange.studentName}}</p>
          </div>
          <div class="change-box" style="margin-bottom: 0.2rem;">
            <img src="@/assets/change.png" style="width:0.32rem;height0.32rem;padding-top:0.16rem;" />
            <p style="font-size:0.13rem;color:rgb(250, 191, 1)">修改推荐人为</p>
          </div>
          <div class="change-box" style="margin-bottom: 0.2rem;">
            <img :src="setInviterChange.inviterImg" class="avatar_img" />
            <p style="font-size:0.14rem;color:#333333">{{setInviterChange.inviterName}}</p>
          </div>
          <!-- <img class="choose-avatar" src="@/assets/home/Receive_icon_close@3x.png"> -->
        </div>

        <!-- 证件材料 -->
        <div class="upload-box flex">
          <span>上传相关证明资料：</span>
        </div>

        <div class="upload-box flex flex-j-c-sb">
          <div class="upload-item">
            <a href="javascript:;" class="file">
              <img :src="testImg[0]" :class="testjudge[0] ? 'img-active':''" />
              <input type="file" id="ida" @change="handleFiles(0, 'myFiles0')" ref="myFiles0" />
            </a>
          </div>
          <div class="upload-item">
            <a href="javascript:;" class="file">
              <img :src="testImg[1]" :class="testjudge[1] ? 'img-active':''" />
              <input type="file" id="idb" @change="handleFiles(1, 'myFiles1')" ref="myFiles1" />
            </a>
          </div>
          <div class="upload-item">
            <a href="javascript:;" class="file">
              <img :src="testImg[2]" :class="testjudge[2] ? 'img-active':''" />
              <input type="file" id="idc" @change="handleFiles(2, 'myFiles2')" ref="myFiles2" />
            </a>
          </div>
        </div>

        <div class="upload-box flex">
          <span>是否已线下给介绍费：</span>
        </div>
        <div class="upload-box flex flex-j-c-sb">
          <div class="upload-item" style="width:35%;">
            <input type="radio" name="jsf" id="jsf1" value="1" style="padding-right:1rem" @click="jsfConfirm(1)">是&nbsp;&nbsp;&nbsp;
            <input type="radio" name="jsf" id="jsf2" value="2" @click="jsfConfirm(2)">否
          </div>
        </div>

        <van-button type="default" class="express-box-btn" @click.native="saveInviterChang">确定</van-button>
        <img src="@/assets/home/Receive_icon_close@3x.png" class="box-close" @click="maskEdit(false)">
      </div>
    </div>

    <div class="mask" v-show="isShowInviter" style="background: rgba(0, 0, 0, 0.7);">
      <img src="@/assets/home/Receive_icon_close@3x.png" class="mask-close" @click="showInvi(false, false)">
      <div class="seach-box">
        <van-search v-model.trim="inviterkw" placeholder="请输入姓名" show-action shape="round" @search="onSearch" style="height:0.5rem;">
          <!-- <div slot="action" @click="showInvi({isEdit: true}, false)" style="color:#FABF01">取消</div> -->
          <div slot="action" @click="onSearch" style="color:#FABF01">搜索</div>
        </van-search>
        <div class="per-line flex flex-j-c-sb" v-for="(e, i) in inviterArr" :key="`${i}one`">
          <div class="flex flex-a-i-center">
            <img :src="e.avatar_url || require('@/assets/teamAvatar.png')" class="item-avatar" />
            <div class="item-box flex flex-a-i-center flex-j-c-sb">
              <p class="item-name">{{e.true_name || e.nickname}}</p>
            </div>
          </div>
          <div class="flex flex-a-i-center" @click="toEdit(e)">
            <p class="item-text">选择</p>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import {
  teacherForder,
  teacherSend,
  searchInviter,
  uploadImg,
  postInviter,
  previewSubmit,
  modityLink,
  cityLink,
  campusLink,
  forderSubmit,
  REQUEST_BASE,
  getMessage,
  FuserMsg,
  getOrigin,
} from '@/api'
import { Indicator, MessageBox, Toast } from 'mint-ui'
import DataNull from '@/components/DataNull'
import Nomore from '@/components/Nomore'
import Navbar from '@/components/Navbar.vue'
import expressData from '@/js/express.json'

export default {
  name: 'PreEnrolled',
  components: {
    DataNull,
    Nomore,
    Navbar,
  },
  data() {
    return {
      popupVisible: false, // picker 显示/隐藏
      popupType: '', // 联动类型
      popupName: '', // 联动名称
      Indexes: 'name', // 联动索引
      slots: [{ values: [] }],
      arrangement: {}, // 层次
      typeInfoList: [],
      OriginInfoList: [],
      selected: 0,
      // selecteData: [{id: 2, name: '紧急联系人', num: 0}, {id: 1, name: '物流信息', num: 0}],
      pageData: { list: [], fans: [], enroll: [] }, // 获取预报名数据
      titleType: {}, // 报读类型
      college: {}, // 校区
      dwname: '', // 单位名称
      clman: '', //紧急联系人姓名
      county: '',
      clue: {}, //线索来源
      clueType: {}, //渠道来源
      clueData: [
        { id: 1, name: '线上' },
        { id: 2, name: '线下' },
      ],
      arrangement: {}, // 层次
      major: {}, // 专业
      city: [{ id: 1941 }, { id: 1942 }], // 城市
      cityShow: '', // 城市展示数据
      cityData: '', // 获取的城市数据
      changeCityIndex: [0, 0, 0], // 城市更改id
      servicCampus: {}, // 服务校区
      servicCampusArr: [], // 校区联动数据
      pageLists: [], // 页面列表
      loading: true,
      page: 1,
      shownull: false,
      showNoMore: false,
      kw: '',
      showMask: false, // 是否启用补充信息
      showEdit: false, // 是否启更改推荐人
      isShowInviter: false,
      inviterkw: '', // 搜索推荐人
      inviterArr: [], // 推荐人数据
      testjudge: [false, false, false, false], // 判断是否已上传相关证件
      testImg: [
        require('@/assets/jia.png'),
        require('@/assets/jia.png'),
        require('@/assets/jia.png'),
        require('@/assets/jia.png'),
      ], // 相关证件上传默认图片
      //推荐人变更数据
      setInviterChange: {},
      setData: {
        true_name: '',
        express: '请选择',
        express_no: '',
        critical_true_name: '',
        critical_mobile_phone: '',
        idcard: '',
        unit: '',
        clue: '',
        clueType: '',
        campus: '',
        crash_mobile: '',
        binding: '',
        crash_linkman: '',
        second_name: '',
        goods_name: '',
        address: '',
        county: '',
      },
      oid: '',
      pageIndex: 0,
    }
  },
  created() {},
  mounted() {
    this.getOriginInfo()
    this.getPreView()
    this.getCampus()
    this.kw = this.$route.query.kw || ''
    this.getpageData()
    this.getCity()
  },
  watch: {
    $route(a, b) {
      this.loading = true
      this.page = 1
      this.shownull = false
      this.showNoMore = false
      this.kw = this.$route.query.kw || ''
      this.pageLists = []
      this.getpageData()
    },
  },
  methods: {
    forbid() {
      Toast({ message: '不能修改层次', className: 'iconfont icon-close' })
    },
    //选择城市
    regionChange(data) {
      console.log(data)

      // console.log(
      //   data.province.value + '-' + data.city.value + '-' + data.area.value + '-' + data.town.value
      // )
      if (data.province != null) {
        this.county = data.province.value
      }
      console.log(this.county)
      if (data.city != null) {
        this.county = this.county + '-' + data.city.value
      }
      console.log(this.county)
      if (data.area != null) {
        this.county = this.county + '-' + data.area.value
      }
      console.log(this.county)
      if (data.town != null) {
        this.county = this.county + '-' + data.town.value
      }
      console.log(this.county)
    },
    //获取来源数据
    getOriginInfo() {
      getOrigin().then((res) => {
        console.log(res.data)
        this.OriginInfoList = res.data
      })
    },
    // 数据获取接口
    getPreView() {
      previewSubmit().then((res) => {
        console.log(res.data)
        if (res.code === 102) {
          Toast({ message: '已存在报名记录', className: 'iconfont icon-close', duration: 1500 })
          setTimeout(() => {
            this.$router.push({ name: 'Order' })
          }, 1500)
        } else {
          this.pageData = res.data

          // 报读类型
          if (this.pageData.enroll.length !== 0) {
            this.titleType = this.pageData.enroll[this.pageData.enroll.length - 1]
            // this.titleType = 1
          }
          // 院校
          if (this.pageData.list.length !== 0) {
            let colObj = {}
            this.pageData.list.map((item, index) => {
              if (item.id == 68) {
                this.college = item
                console.log(this.college)
                // this.arrangement = item.son[0];
                // this.getModity(1)
                colObj.item = item
                colObj.index = index
              }
            })
            this.pageData.list.splice(colObj.index, 1)
            this.pageData.list.push(colObj.item)
          }
        }
        let paramsData = JSON.parse(sessionStorage.getItem('_previewData'))
        console.log(paramsData)
        if (paramsData) {
          console.log(paramsData.params.county)
          this.cmobile = paramsData.params.cmobile
          this.county = paramsData.params.county
          this.dwname = paramsData.params.dwname
          this.titleType = paramsData.paramsShow.enrolment
          this.college = paramsData.paramsShow.first_cat
          this.arrangement = paramsData.paramsShow.second_cat
          this.major = paramsData.paramsShow.goods
          this.servicCampus = paramsData.paramsShow.campus
        }
        window.scrollTo(0, 0)
      })
    },
    // 城市联动接口
    getCity() {
      cityLink().then((res) => {
        this.cityData = res.data
        let defaultCity = [{}, {}],
          cindex = 0
        if (res.data.length !== 0) {
          this.city = defaultCity
          this.cindex = cindex
          this.cityShow = localStorage.getItem('cityShow')
          // this.cityShow = `${this.city[0].name}-${this.city[1].name}`
        }
      })
    },
    // 专业联动数据接口
    getModity(e) {
      let params = {
        first_cat_id: this.college.id,

        // first_cat_id: 1, // 院校id
        second_cat_id: this.arrangement.id, // 层次id
        // second_cat_id: 1,
      }
      modityLink(params).then((res) => {
        if (res.code === 0) {
          if (e === 1) {
            this.major = res.data[0]
          } else {
            if (this.slots[0].values !== res.data) {
              this.slots = [{ flex: 1, values: res.data, className: 'slot1', textAlign: 'center' }]
              this.popupType = 'major'
              this.popupName = '选择专业'
              this.Indexes = 'name'
            }
            this.popupVisible = true
          }
        } else {
          Toast({ message: res.msg, className: 'iconfont icon-close' })
        }
      })
    },
    // 校区联动接口
    getCampus(e = this.city[1].id) {
      console.log((e = this.city[1].id))
      campusLink({ city_id: e }).then((res) => {
        if (res.code === 0) {
          // if(this.slots[0].values !== res.data) {
          //   this.slots = [{flex: 1, values: res.data, className: 'slot1', textAlign: 'center'}];
          //   this.Indexes = 'name';
          //   this.popupType = 'servicCampus';
          //   this.popupName = '选择校区';
          // }
          // this.popupVisible = true;
          this.servicCampusArr = res.data
          // this.servicCampus = res.data[0];
        } else {
          this.servicCampus = { name: '暂无' }
        }
      })
    },
    loadMore() {
      if (this.loading) return false
      this.loading = true
      this.page += 1
      this.getpageData()
    },
    // 列表数据获取
    getpageData() {
      teacherForder({ page: this.page, limit: 10, type: 2, keyword: this.kw }).then((res) => {
        this.pageLists = []
        console.log(res.data)
        if (res.code === 0) {
          this.pageLists = this.pageLists.concat(res.data)
          if (res.data.length === 0) {
            this.shownull = true
          }
          if (res.data.length === 10) {
            this.loading = false
          }
          if (res.data.length !== 10 && res.data.length !== 0) {
            this.showNoMore = true
          }
          if (Number(res.totalCount) === this.pageLists.length) {
            this.loading = true
            this.showNoMore = true
          }
        } else {
          this.shownull = true
        }
      })
    },
    // 保存配送方式
    saveExpress() {
      if (this.selected === 1) {
        if (
          (this.setData.express !== '请选择' && this.setData.express_no) ||
          this.setData.express === '校区自取'
        ) {
          this.saveMsg({
            order_id: this.oid,
            send_type: 'express',
            express: this.setData.express,
            express_no: this.setData.express_no,
          })
        } else {
          Toast({ message: '请完善信息', className: 'iconfont icon-close' })
        }
      } else {
        if (!this._tools.checkPhone(String(this.setData.binding))) {
          Toast({
            message: '请输入正确的手机号码',
            className: 'iconfont icon-close',
            duration: 1500,
          })
          return false
        }

        console.log(this.major.mame)
        this.saveMsg({
          order_id: this.oid,
          critical_true_name: this.setData.critical_true_name,
          binding: this.setData.binding,
          idcard: this.setData.idcard,
          unit: this.setData.unit,
          true_name: this.setData.true_name,
          county: this.county,
          crash_mobile: this.setData.crash_mobile,
          crash_linkman: this.setData.crash_linkman,

          second_name: this.arrangement.name,
          goods_name: this.setData.goods_name,
          address: this.setData.address,
          clueType: this.setData.clueType,
          clue: this.setData.clue,
          campus: this.servicCampus.name,
        })
      }
    },
    // 补充信息
    toSend(e, i) {
      console.log(e)
      this.setData.true_name = e.true_name
      this.mask(true)
      this.oid = e.id
      this.pageIndex = i
      this.setData.express = e.express
      this.setData.express_no = e.express_no
      this.setData.critical_true_name = e.critical_true_name
      this.setData.binding = e.binding
      this.setData.idcard = e.idcard
      this.setData.campus = e.campus
      this.setData.unit = e.unit
      this.setData.crash_mobile = e.crash_mobile
      this.setData.crash_linkman = e.crash_linkman
      this.setData.address = e.address
      this.arrangement.name = e.second_name
      this.college.name = e.first_name
      this.major.name = e.goods_name
      this.servicCampus.name = e.campus
      this.setData.county = e.county
      this.setData.clue = e.clue
      this.setData.clueType = e.clueType
      this.county = e.county
      console.log(this.county)
    },
    // 补充信息开关
    mask(e) {
      this.showMask = e
    },
    toEdit(e) {
      this.maskEdit(true)
      this.isShowInviter = false
      if (e) {
        this.setInviterChange.inviterId = e.id
        this.setInviterChange.inviterName = e.true_name
        this.setInviterChange.inviterImg = e.avatar_url
      } else {
        this.setInviterChange = {}
      }
    },
    // 更改推荐人页面
    maskEdit(e) {
      this.showEdit = e
      if (!e) {
        this.setInviterChange = {}
      }
    },
    // 搜索
    onSearch() {
      searchInviter({ keyword: this.inviterkw }).then((res) => {
        if (res.code === 0) {
          this.inviterArr = res.data
        } else {
          Toast({ message: res.msg, className: 'iconfont icon-close' })
        }
      })
    },
    // 打开&关闭推荐人搜索
    showInvi(e, i) {
      this.inviterArr = []
      this.isShowInviter = i
      if (e) {
        this.setInviterChange.orderId = e.id
        this.setInviterChange.studentId = e.user_id
        this.setInviterChange.studentName = e.true_name
        this.setInviterChange.studentImg = e.avatar_url
      } else {
        this.setInviterChange = {}
      }
    },
    handleFiles(index, e) {
      if (this.$refs[e].files.length === 0) return false
      const isLt1M = this.$refs[e].files[0].size / 1024 / 1024 < 1
      // if (!isLt1M) {
      //   Toast({message: '上传图片大小不能超过 1MB!', className: 'iconfont icon-close'});
      //   return
      // }
      var windowURL = window.URL || window.webkitURL
      if (this.$refs[e].files !== 0) {
        this.param = { name: this.$refs[e].files[0] }
        uploadImg(this.param).then((res) => {
          if (res.code === 0) {
            this.testjudge.splice(index, 1, true)
            this.testImg.splice(index, 1, windowURL.createObjectURL(this.$refs[e].files[0]))
            switch (index) {
              case 0:
                this.setInviterChange.imgOne = res.data.url
                break
              case 1:
                this.setInviterChange.imgTwo = res.data.url
                break
              case 2:
                this.setInviterChange.imgThree = res.data.url
                break
              default:
                break
            }
          } else {
            Toast({ message: res.msg, className: 'iconfont icon-close' })
          }
        })
      }
      // console.log(this.testImg)
    },
    //介绍费按钮
    jsfConfirm(val) {
      this.setInviterChange.jsf = val
    },
    //修改推荐人申请
    saveInviterChang() {
      //console.log(this.setInviterChange);
      if (this.setInviterChange) {
        postInviter(this.setInviterChange).then((res) => {
          if (res.code === 0) {
            Toast({ message: res.msg, className: 'iconfont icon-dui' })
            this.maskEdit(false)
            this.testjudge = [false, false, false, false] // 判断是否已上传相关证件
            this.testImg = [
              require('@/assets/jia.png'),
              require('@/assets/jia.png'),
              require('@/assets/jia.png'),
              require('@/assets/jia.png'),
            ] // 相关证件上传默认图片
          } else {
            Toast({ message: res.msg, className: 'iconfont icon-close' })
          }
        })
      } else {
        Toast({ message: '页面超时，请重新刷新页面再试！', className: 'iconfont icon-close' })
        this.maskEdit(false)
      }
    },
    // 保存信息
    saveMsg(data) {
      teacherSend(data).then((res) => {
        if (res.code === 0) {
          Toast({ message: '信息已更新', className: 'iconfont icon-dui' })
          this.pageLists[this.pageIndex].express = this.setData.express
          this.pageLists[this.pageIndex].express_no =
            this.setData.express !== '校区自取' ? this.setData.express_no : ''
          this.pageLists[this.pageIndex].critical_true_name = this.setData.critical_true_name
          this.pageLists[this.pageIndex].binding = this.setData.binding
          this.pageLists[this.pageIndex].idcard = this.setData.idcard
          this.pageLists[this.pageIndex].crash_mobile = this.setData.crash_mobile
          this.pageLists[this.pageIndex].crash_linkman = this.setData.crash_linkman
          this.pageLists[this.pageIndex].second_name = this.arrangement.name
          this.pageLists[this.pageIndex].goods_name = this.major.name
          this.pageLists[this.pageIndex].address = this.setData.address
          this.pageLists[this.pageIndex].campus = this.servicCampus.name
          this.pageLists[this.pageIndex].true_name = this.setData.true_name
          this.pageLists[this.pageIndex].clue = this.setData.clue
          this.pageLists[this.pageIndex].county = this.setData.county
          this.pageLists[this.pageIndex].unit = this.setData.unit
          this.pageLists[this.pageIndex].clueType = this.setData.clueType
          this.pageLists[this.pageIndex].county = this.county

          this.mask(false)
        } else {
          Toast({ message: res.msg, className: 'iconfont icon-close' })
        }
      })
    },
    // 选择选项
    showPopup(str) {
      console.log(this.typeInfoList)
      // return false
      let judge = true
      switch (str) {
        case 'ex':
          // if(expressData !== this.slots) {
          this.slots = [{ flex: 1, values: expressData, className: 'slot1', textAlign: 'center' }]
          // this.Indexes = 'name';
          this.popupName = '选择快递'
          // }
          break
        case 'clue': //线索
          this.slots = [{ flex: 1, values: this.clueData, className: 'slot1', textAlign: 'center' }]

          this.Indexes = 'name'
          this.popupName = '选择线索'

          break
        case 'clueType': //渠道
          this.slots = [
            { flex: 1, values: this.typeInfoList, className: 'slot1', textAlign: 'center' },
          ]

          this.Indexes = 'type'
          this.popupName = '选择渠道'

          break
        case 'arrangement': // 层次
          this.slots = [
            { flex: 1, values: this.college.son, className: 'slot1', textAlign: 'center' },
          ]
          this.Indexes = 'name'
          this.popupName = '选择层次'

          break
        case 'college': // 院校
          this.slots = [
            { flex: 1, values: this.pageData.list, className: 'slot1', textAlign: 'center' },
          ]
          this.Indexes = 'name'
          this.popupName = '选择院校'

          break
        case 'major': // 专业
          if (!this.arrangement.id) {
            Toast({ message: '请选择层次', className: 'iconfont icon-close' })
            judge = false
          } else {
            this.getModity(0)
            judge = false
          }

          break
        case 'servicCampus': // 服务校区
          this.slots = [
            { flex: 1, values: this.servicCampusArr, className: 'slot1', textAlign: 'center' },
          ]
          this.Indexes = 'name'
          this.popupName = '选择校区'

          break
        case 'city': // 城市
          let province = this.cityData
          let city = this.cityData[0].list
          let district = this.cityData[0].list[0].list
          console.log(province)
          console.log(city)
          console.log(district)
          // let district = this.cityData[0].list[0].list;
          this.slots = [
            {
              flex: 1,
              values: province,
              className: 'slot1',
              textAlign: 'center',
              defaultIndex: this.cindex,
            },
            {
              divider: true,
              content: '-',
              className: 'slot2',
            },
            {
              flex: 1,
              values: city,
              className: 'slot3',
              textAlign: 'center',
            },

            {
              divider: true,
              content: '-',
              className: 'slot2',
            },
            {
              flex: 1,
              values: district,
              className: 'slot4',
              textAlign: 'center',
            },
          ]
          this.servicCampus = {}
          this.popupName = '城市'
          break
        default:
          break
      }
      if (judge) {
        this.popupVisible = true
        this.popupType = str
      }
    },
    // 确定选项
    handleConfirm() {
      switch (this.popupType) {
        case 'ex':
          this.setData.express = this.$refs.picker.getValues()[0]
          if (this.setData.express === '校区自取') {
            this.setData.express_no = ''
          }
          break
        case 'clue':
          this.setData.clue = this.$refs.picker.getValues()[0].name
          console.log(this.$refs.picker.getValues()[0])
          console.log(this.setData.clue)
          //筛选数据
          this.typeInfoList = this.OriginInfoList.filter((item) => {
            return item.origin == this.$refs.picker.getValues()[0].id
          })
          this.setData.clueType = ''
          console.log(this.typeInfoList)
          break
        case 'clueType':
          this.setData.clueType = this.$refs.picker.getValues()[0].type
          console.log(this.$refs.picker.getValues()[0])
          console.log(this.setData.clueType)

          break
        case 'arrangement':
          this.arrangement = this.$refs.picker.getValues()[0]
          console.log(this.arrangement.name)

          if (this.college.id == 68) {
            this.getModity(1)
          } else {
            this.major = {}
          }
          break
        case 'major':
          this.major = this.$refs.picker.getValues()[0]
          console.log(this.major.name)
          this.setData.goods_name = this.major.name

          break
        case 'college':
          this.college = this.$refs.picker.getValues()[0]
          // this.arrangement = {} // 层次清空
          this.major = {} // 专业清空
          break
        case 'servicCampus':
          this.servicCampus = this.$refs.picker.getValues()[0]

          break
        case 'city':
          console.log(this.$refs.picker.getValues())
          this.city = [
            this.$refs.picker.getValues()[0],
            this.$refs.picker.getValues()[1],
            this.$refs.picker.getValues()[2],
          ]
          this.county = `${this.city[0].name}-${this.city[1].name}-${this.city[2].name}`
          console.log(this.county)
          this.setData.county = this.county
          // localStorage.setItem('cityShow', this.cityShow)

          break
        default:
          break
      }
      this.popupVisible = false
    },
    onValuesChange(picker, values) {
      console.log(values)

      if (this.popupType === 'city') {
        let province = values[0]
        console.log(province)
        let city = values[1]
        console.log(city)
        let district = values[2]
        console.log(district)
        if (province.id !== this.changeCityIndex[0].id) {
          this.changeCityIndex[0] = province.id
          picker.setSlotValues(1, province.list)
          // picker.setSlotValues(2, province.list[0].list)
        }
        if (city.id !== this.changeCityIndex[1].id) {
          this.changeCityIndex[1] = city.id
          picker.setSlotValues(2, city.list)
        }
        if (district.id !== this.changeCityIndex[2].id) {
          this.changeCityIndex[2] = district.id
          picker.setSlotValues(2, province.list[0].list)
          picker.setSlotValues(2, city.list)
          console.log(province.list[0].list)
        }
      }
    },
    // 跳转订单预览
    topage(e) {
      this.$router.push({ path: `/Order?tId=${e.user_id}` })
    },
  },
}
</script>

<style lang="less" scoped>
.pre-context {
  padding: 1.64rem 0 0.1rem;
  .context-card {
    width: 3.43rem;
    padding: 0.1rem;
    margin: 0 auto 0.1rem;
    background: white;
    border-radius: 5px;
    .change-box {
      img {
        width: 0.3rem;
        height: 0.3rem;
      }
      p {
        font-size: 0.125rem;
        color: #999;
      }
      .avatar_img {
        width: 0.62rem;
        height: 0.62rem;
        border-radius: 50%;
      }
    }
    .card-left {
      flex-direction: column;
    }
    .card-right {
      flex-direction: column;
    }
  }
  .add-card {
    height: 1rem;
  }
}
.text-style {
  border: none;
  background: #f6f6fa;
  border-radius: 3px;
  height: 0.25rem;
  padding: 0 0.05rem;
  min-width: 0.93rem;
  line-height: 0.25rem;
}
.text-line {
  line-height: 0.3rem;
  font-size: 0.125rem;
  .text-left {
    width: 0.9rem;
    text-align: right;
    color: #999;
  }
  .text-right {
    max-width: 1.5rem;
    a {
      color: #2c3e50;
    }
  }
}
.express-box {
  width: 80%;
  height: auto;
  padding: 0.2rem 0.16rem;
  background: white;
  border-radius: 0.1rem;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  .express-box-btn {
    width: 80%;
    margin: 0.2rem auto 0;
    border-radius: 0.2rem;
    height: 0.35rem;
    color: white;
    background: linear-gradient(90deg, #fabf01, #fa9901);
    line-height: 0.35rem;
  }
  .box-close {
    width: 0.25rem;
    height: 0.25rem;
    position: absolute;
    bottom: -0.5rem;
    left: 50%;
    transform: translateX(-50%);
  }
}
.mint-popup {
  width: 100%;
  border-radius: 8px 8px 0 0;
}
.mint-popup /deep/ .picker {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  background: white;
  border-radius: 8px 8px 0 0;
  .mint-header {
    background: white;
    height: 0.5rem;
    padding: 0 0.16rem;
    font-size: 0.15rem;
    .is-left {
      color: #999999;
    }
    .is-right {
      color: #fabf01;
    }
  }
  .mint-header-title {
    font-size: 0.17rem;
    color: black;
  }
}
/deep/ .picker-selected {
  color: #fabf01;
}
/deep/ .mint-datetime-confirm {
  color: #fabf01;
}
/deep/ .mint-datetime-cancel {
  color: #999;
}
.per-line {
  height: auto;
  line-height: 0.4rem;
  padding: 0.1rem 0.16rem;
  background: white;
}
.item-avatar {
  width: 0.56rem;
  height: 0.56rem;
  margin-right: 0.12rem;
  border-radius: 50%;
}
.item-name {
  font-size: 0.16rem;
  width: 100%;
  margin-bottom: 0.1rem;
}
.item-time {
  color: #999999;
  font-size: 0.12rem;
  width: 100%;
  text-align: right;
  margin-bottom: 0.1rem;
}
.item-text {
  font-size: 0.14rem;
  color: white;
  width: 0.7rem;
  height: 0.24rem;
  line-height: 0.24rem;
  border-radius: 0.12rem;
  background: linear-gradient(90deg, #fabf01, #fa9901);
  text-align: center;
}
.item-texts {
  background: white;
  border: 1px solid #fabf01;
  color: #fabf01;
  margin-right: 0.1rem;
}
.seach-box {
  width: 90%;
  padding: 0.16rem;
  position: relative;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  background: white;
  border-radius: 0.1rem;
  max-height: 55vh;
  overflow-y: scroll;
  & > div {
    border: none;
  }
}
.mask-close {
  width: 0.3rem;
  height: 0.3rem;
  position: absolute;
  top: 0.5rem;
  right: 5%;
  // left: 50%;
  // transform: translateX(-50%);
}
.upload-box {
  padding: 0.1rem 0.2rem;
  background: white;
  .upload-item {
    width: 30%;
    p {
      font-size: 0.12rem;
      color: #999999;
    }
  }
  .file {
    position: relative;
    display: inline-block;
    background: #f7f7f7;
    border: 1px dashed #7d7d7d;
    border-radius: 4px;
    overflow: hidden;
    color: #1e88c7;
    width: 100%;
    height: 0.8rem;
    img {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 0.28rem;
      height: 0.28rem;
    }
    .img-active {
      width: 100%;
      height: 100%;
    }
  }
  .file input {
    position: absolute;
    font-size: 100px;
    right: 0;
    top: 0;
    opacity: 0;
  }
  .avatar_img {
    width: 0.62rem;
    height: 0.62rem;
    border-radius: 50%;
  }
}
/deep/ div.rg-select div.rg-select__el div.rg-select__content {
  padding: 0;
}
</style>
